import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { productionOrderDetailsNCFileConfig } from './config';

const ProductionOrderDetailsNCFileStack = createStackNavigator();

const ProductionOrderDetailsNCFileNavigator = () => {
  return (
    <ProductionOrderDetailsNCFileStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {productionOrderDetailsNCFileConfig.map(({ Component, name }) => (
        <ProductionOrderDetailsNCFileStack.Screen key={name} name={name} component={Component} />
      ))}
    </ProductionOrderDetailsNCFileStack.Navigator>
  );
};

export { ProductionOrderDetailsNCFileNavigator };
